import { render, staticRenderFns } from "./ColumnHeader.vue?vue&type=template&id=4b0e5836&scoped=true&"
import script from "./ColumnHeader.vue?vue&type=script&lang=ts&"
export * from "./ColumnHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnHeader.vue?vue&type=style&index=0&id=4b0e5836&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0e5836",
  null
  
)

export default component.exports